/**
 * Product experience carousel: arrows, dots, optional touch swipe.
 * Re-runs on shopify:section:load.
 */
(function () {
  var SWIPE_THRESHOLD = 50;

  function findEl(root, sel) {
    return root.querySelector(sel);
  }
  function findEls(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function initCarousel(container) {
    if (!container || container._productExperienceInit) return;
    container._productExperienceInit = true;

    var track = findEl(container, '[data-experience-track]');
    var slides = findEls(container, '[data-experience-slide]');
    var prevBtn = findEl(container, '[data-experience-prev]');
    var nextBtn = findEl(container, '[data-experience-next]');
    var dots = findEls(container, '[data-experience-dot]');

    if (!track || slides.length === 0) return;

    var total = slides.length;
    var currentIndex = 0;

    function scrollToIndex(index) {
      var i = ((index % total) + total) % total;
      currentIndex = i;
      var slide = slides[i];
      if (slide && track) {
        var targetLeft = slide.offsetLeft;
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } else {
          track.scrollLeft = targetLeft;
        }
      }
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === i);
      });
    }

    function goPrev() {
      scrollToIndex(currentIndex - 1);
    }
    function goNext() {
      scrollToIndex(currentIndex + 1);
    }

    container._experienceGoPrev = goPrev;
    container._experienceGoNext = goNext;

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (!Number.isNaN(idx)) scrollToIndex(idx);
      });
    });

    if (track) {
      var trackStyle = window.getComputedStyle(track);
      var gapPx = parseFloat(trackStyle.gap) || 8;
      track.addEventListener('scroll', function () {
        var scrollLeft = track.scrollLeft;
        var slideWidth = slides[0] ? slides[0].offsetWidth + gapPx : 0;
        if (slideWidth > 0) {
          var newIndex = Math.round(scrollLeft / slideWidth);
          newIndex = Math.max(0, Math.min(newIndex, total - 1));
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            dots.forEach(function (dot, idx) {
              dot.classList.toggle('is-active', idx === currentIndex);
            });
          }
        }
      });
    }
  }

  function run() {
    document.querySelectorAll('[data-product-experience-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.querySelector && section.querySelector('[data-product-experience-carousel]')) {
      var wrap = section.querySelector('[data-product-experience-carousel]');
      if (wrap) wrap._productExperienceInit = false;
      initCarousel(wrap);
    }
  });
})();
